module.exports = __webpack_public_path__ + "static/media/Escalation-Closebtn.5b7f35a1.svg";